import Navbar from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Carousel } from "./components/Carousel";
import { Propuestas } from "./components/Propuestas";

function App() {
  return (
    <div>
      <Navbar />
      <Hero />
      <Carousel />
      <Propuestas />
    </div>
  );
}

export default App;
